import { ChartSeries } from './charts/chart.component';

export const ATTRITION_SERIES: ChartSeries[] = [
  { key: 'joiners', label: 'Joiners', color: '#167544' },
  { key: 'leavers', label: 'Leavers', color: '#b42318' },
];

export const CLAIMS_SERIES: ChartSeries[] = [
  { key: 'Expense Count', label: 'Expense Count', color: '#60259e' },
  { key: 'Approved Count', label: 'Approved Count', color: '#167544' },
  { key: 'Pending Count', label: 'Pending Count', color: '#966500' },
  { key: 'Rejected Count', label: 'Rejected Count', color: '#b42318' },
];

/** Mirror the completed-month API defaults; an explicit From overrides the span. */
export function reportingPeriod(startMonth: string, endMonth: string, defaultMonths: number, now = new Date()): string {
  const parse = (month: string) => {
    const [year, number] = month.split('-').map(Number);
    return new Date(year, number - 1, 1);
  };
  const end = endMonth ? parse(endMonth) : new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const start = startMonth ? parse(startMonth) : new Date(end.getFullYear(), end.getMonth() - defaultMonths + 1, 1);
  const formatter = new Intl.DateTimeFormat('en', { month: 'short', year: 'numeric' });
  return `${formatter.format(start)} – ${formatter.format(end)}`;
}
